var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatioIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V9.75C1.5 10.1642 1.83579 10.5 2.25 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V2.25C10.5 1.83579 10.1642 1.5 9.75 1.5Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00098 5.62695C6.16674 5.62695 6.32571 5.56111 6.44292 5.44389C6.56013 5.32668 6.62598 5.16771 6.62598 5.00195C6.62598 4.83619 6.56013 4.67722 6.44292 4.56001C6.32571 4.4428 6.16674 4.37695 6.00098 4.37695C5.83522 4.37695 5.67625 4.4428 5.55903 4.56001C5.44182 4.67722 5.37598 4.83619 5.37598 5.00195C5.37598 5.16771 5.44182 5.32668 5.55903 5.44389C5.67625 5.56111 5.83522 5.62695 6.00098 5.62695ZM6.00098 7.62695C6.16674 7.62695 6.32571 7.56111 6.44292 7.44389C6.56013 7.32668 6.62598 7.16771 6.62598 7.00195C6.62598 6.83619 6.56013 6.67722 6.44292 6.56001C6.32571 6.4428 6.16674 6.37695 6.00098 6.37695C5.83522 6.37695 5.67625 6.4428 5.55903 6.56001C5.44182 6.67722 5.37598 6.83619 5.37598 7.00195C5.37598 7.16771 5.44182 7.32668 5.55903 7.44389C5.67625 7.56111 5.83522 7.62695 6.00098 7.62695Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87598 4.24805V7.74805M8.12598 4.24805V7.74805",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatioIconBlack);
export default __webpack_public_path__ + "static/media/RatioIconBlack.a7f2adc35470dc481669a74b39eccaec.svg";
export { ForwardRef as ReactComponent };